var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconAttachment = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 22a5.42 5.42 0 01-5.54-5.4V5.88a3.86 3.86 0 014-3.83 3.87 3.87 0 014 3.83v9.19A2.3 2.3 0 0112 17.36a2.29 2.29 0 01-2.38-2.29V7.41a.74.74 0 01.79-.77.74.74 0 01.8.77v7.66a.8.8 0 001.59 0V5.88a2.31 2.31 0 00-2.39-2.3 2.3 2.3 0 00-2.38 2.3V16.6a3.86 3.86 0 004 3.82 3.86 3.86 0 004-3.82V7.41a.8.8 0 011.59 0v9.19A5.43 5.43 0 0112 22z",
  fill: "#787878"
})));

export default SvgIconAttachment;